import type { FunctionComponent, ReactNode } from "react";
import { cn } from "./cn";

export interface DividerProps {
  /** Optional centered label between the two rules. */
  children?: ReactNode;
  className?: string;
}

/** Horizontal rule; with children, a centered label flanked by rules. */
export const Divider: FunctionComponent<DividerProps> = ({ children, className }) => {
  if (!children) {
    return <hr className={cn("my-6 w-full border-0 border-t border-noa", className)} />;
  }

  return (
    <div
      role="separator"
      className={cn(
        "my-4 flex items-center gap-4 font-medium text-noa before:flex-1 before:border-t before:border-noa after:flex-1 after:border-t after:border-noa",
        className
      )}
    >
      {children}
    </div>
  );
};
